export default '8EB8E';
